import { ResourceCatalogueItem } from '../types/quote';
import apiClient from './client';

export async function getResourceCatalogue(): Promise<ResourceCatalogueItem[]> {
  const response = await apiClient.get<ResourceCatalogueItem[]>('/ResourceCatalogue');
  return response.data;
}

export async function createResourceCatalogueItem(description: string, ratePerHour: number): Promise<ResourceCatalogueItem> {
  const response = await apiClient.post<ResourceCatalogueItem>('/ResourceCatalogue', { description, ratePerHour });
  return response.data;
}

export async function updateResourceCatalogueItem(id: number, description: string, ratePerHour: number): Promise<ResourceCatalogueItem> {
  const response = await apiClient.put<ResourceCatalogueItem>(`/ResourceCatalogue/${id}`, { description, ratePerHour });
  return response.data;
}

export async function deleteResourceCatalogueItem(id: number): Promise<void> {
  await apiClient.delete(`/ResourceCatalogue/${id}`);
}
